<template>
  <div class="wrapper w-100 flex-center not-found-wrapper">
    <div class="text-column">
      <div class="title">{{$lang.messages.not_found.title}}</div>
      <div class="description">{{$lang.messages.not_found.description}}</div>
      <div class="description sub-description">
        {{$lang.messages.not_found.please}}
        <a href="/contact">{{$lang.messages.not_found.link}}</a>
        {{$lang.messages.not_found.linkText}}
      </div>
    </div>
    <div>
      <img src="../assets/img/404.svg" alt="not found">
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/helpers";
.not-found-wrapper {
  padding: 0 15px;

  @include responsive-below($md){
    flex-wrap: wrap;
    padding: 40px 15px;
  }
}
.title {
  font-weight: 800;
  font-size: 36px;
  line-height: 49px;
  margin-bottom: 8px;
  color: #444B63;
}

.description {
  color: #444B63;
  font-size: 16px;
  opacity: 0.8;
}

.sub-description {
  margin-top: 150px;

  @include responsive-below($md){
    margin: 0;
  }
}

.text-column {
  max-width: 252px;
  margin-right: 100px;

  @include responsive-below($md){
    margin: 0;
  }
}
</style>
